import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';

export const DetailsContainer = styled(Box)({
  border: '1px solid #707070',
  borderRadius: '8px',
  marginTop: 18,
});

export const StyledHeaderCell = styled(TableCell)({
  fontWeight: 'bold',
  fontSize: '0.8rem',
});
